/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Geofences Polygon Icon component.
 */
export const GeofencesPolygonIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 22 22' fill='none'>
      <path d='M9.02265 1.50256L1.34627 8.81815C1.1526 9.00272 1.13853 9.30704 1.31435 9.50869L10.9376 20.5461C11.1433 20.782 11.5127 20.7731 11.7067 20.5275L21.3599 8.31207C21.619 7.98421 21.3855 7.50206 20.9676 7.50206H12.5838C12.3817 7.50206 12.1995 7.38043 12.122 7.19381L9.82937 1.67277C9.69475 1.34859 9.27676 1.2604 9.02265 1.50256Z'
        stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};
